import React from "react";
import { BarChart3, Target, CheckCircle, Clock, Award, Users, Star } from "lucide-react";

const metricColor = (v) =>
  v >= 90 ? "linear-gradient(90deg,#10b981,#059669)"
  : v >= 80 ? "linear-gradient(90deg,#3b82f6,#2563eb)"
  : v >= 70 ? "linear-gradient(90deg,#f59e0b,#d97706)"
  : "linear-gradient(90deg,#ef4444,#dc2626)";

const achievementIcons = [Award, Star, Users, Target];

const PerformanceTab = ({
  styles,
  theme,
  isRTL,
  screenSize,
  performanceData,
  handleMouseEnter,
  handleMouseLeave,
  t,
  getMetricLabel,
}) => {
  const iconSize = screenSize.isMobile ? 18 : 24;

  return (
    <div style={styles.singleColumn}>
      <div style={styles.twoColumn}>
        {/* Performance Metrics */}
        <div style={styles.card} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <h3 style={styles.cardTitle}>
            <BarChart3 size={iconSize} />
            {t("performanceMetrics")}
          </h3>
          {Object.entries(performanceData.metrics).map(([key, value]) => (
            <div key={key} style={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <span style={{ color: theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)", textTransform: "capitalize" }}>
                  {getMetricLabel(key)}
                </span>
                <span style={{ color: theme === "dark" ? "white" : "#1a1a1a", fontWeight: "600" }}>
                  {value}%
                </span>
              </div>
              <div style={styles.progressBar}>
                <div style={{ ...styles.progressFill, width: `${value}%`, background: metricColor(value) }} />
              </div>
            </div>
          ))}
        </div>

        {/* Goals Progress */}
        <div style={styles.card} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <h3 style={styles.cardTitle}>
            <Target size={iconSize} />
            {t("goalsProgress")}
          </h3>
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <CheckCircle style={styles.statIcon} size={screenSize.isMobile ? 28 : 32} color="#10b981" />
              <div style={styles.statValue}>{performanceData.goals.completed}</div>
              <div style={styles.statLabel}>{t("completed")}</div>
            </div>
            <div style={styles.statCard}>
              <Clock style={styles.statIcon} size={screenSize.isMobile ? 28 : 32} color="#f59e0b" />
              <div style={styles.statValue}>{performanceData.goals.inProgress}</div>
              <div style={styles.statLabel}>{t("inProgress")}</div>
            </div>
            <div style={styles.statCard}>
              <Target style={styles.statIcon} size={screenSize.isMobile ? 28 : 32} color="#3b82f6" />
              <div style={styles.statValue}>{performanceData.goals.total}</div>
              <div style={styles.statLabel}>{t("totalGoals")}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Achievements */}
      <div style={styles.card} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <h3 style={styles.cardTitle}>
          <Award size={iconSize} />
          {t("achievements")}
        </h3>
        <div style={styles.achievementGrid}>
          {performanceData.achievements.map((achievement, index) => {
            const Icon = achievementIcons[index % achievementIcons.length];
            return (
              <div key={index} style={styles.achievementCard}>
                <Icon style={styles.achievementIcon} size={screenSize.isMobile ? 32 : 40} />
                <div style={styles.achievementTitle}>{achievement.title}</div>
                <div style={styles.achievementDate}>{achievement.date}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PerformanceTab;